import React, { useEffect, useState } from 'react'
import {Navigate, useNavigate} from 'react-router-dom'
import { Container } from 'semantic-ui-react'
import TripList from './TripList'
import { useAuth } from '../context/AuthContext'
import { tripApi } from '../misc/TripApi'
import { handleLogError } from '../misc/Helpers'

function TripListPage() {
    const Auth = useAuth()
    const user = Auth.getUser()
    const isUser = user.role === 'USER'
    const navigate = useNavigate()

    const [trips, setTrips] = useState([])
    const [isTripsLoading, setIsTripsLoading] = useState(false)

    useEffect(() => {
        handleGetTrips()
    }, [])

    const handleGetTrips = async () => {
        try {
            setIsTripsLoading(true)
            const response = await tripApi.getTrips(user)
            setTrips(response.data)
        } catch (error) {
            handleLogError(error)
        } finally {
            setIsTripsLoading(false)
        }
    }

    const handleBooking = async (id) => {
        navigate('/booking/'+id);
    }

    if (!isUser) {
        return <Navigate to='/' />
    }

    return (
        <Container>
            <TripList
                isTripsLoading={isTripsLoading}
                trips={trips}
                handleBooking={handleBooking}
                user={user}
            />
        </Container>
    )
}

export default TripListPage
